export default {
	mounted: function() {
		let self = this;
		var proDetailTab = 100 / this.$refs.proDetailTab.querySelectorAll("li").length;
		for(var i=0; i<this.$refs.proDetailTab.querySelectorAll("li").length; i+=1)
		{
			this.$refs.proDetailTab.querySelectorAll("li")[i].style.width = proDetailTab+'%';
			this.$refs.proDetailTab.querySelectorAll("li")[i].addEventListener("click",function() {
				for(var p=0; p<this.parentNode.childNodes.length; p+=1) this.parentNode.childNodes[p].classList.remove("on");
				this.classList.add('on');
				self.activatedTab = this.getAttribute("data-tab-no");
			});
		}
	}
}